import { Outlet } from 'react-router-dom'
import { useState } from 'react'

import { AppBar, Box, Button, Divider, Drawer, IconButton, List, ListItem, ListItemButton, 
  ListItemText, Toolbar, Typography } from '@mui/material'
import { Menu, Settings } from '@mui/icons-material'

function installApp() {
  // Show the prompt
  // @ts-expect-error
  window?.deferredPrompt?.prompt()
}

const navItems = [
  { label: 'Home', href: './' }, 
  { label: 'Client Story', href: './clientstory' }, 
  { label: 'Life Impacts', href: './lifestory' }, 
  { label: 'Wage Loss', href: './wageloss' }, 
  { label: 'Providers', href: './providers' }, 
  // { label: 'Interview', href: './interview' },
  { label: 'Notes to Lawyer', href: './ntl' },
  // { label: 'Victim Impact Statement', href: './vis' },
  // { label: 'Proof of Wage Loss', href: './proofwageloss' },
  { label: 'Upload Documents', href: './upload' },
]

export default function ClientLayout() {
  const [search, setSearch] = useState("")

  const browserWidth = window.innerWidth
  const image = browserWidth < 600 ? "/LegalLoop/Legalloop_LL_Icon_40h_transparent.png" : "/LegalLoop/Legalloop_LL_Icon_40h_transparent.png"
  const drawerWidth = 240
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }

  function logout() {
    window.localStorage.removeItem('L25.clientCaseId')
    window.location.href = '/clientui/'
  }

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Links
      </Typography>
      <Divider />
      <List>
        {navItems.map((ni, i) => (
          <ListItem key={i} disablePadding>
            <ListItemButton href={ni.href} sx={{ textAlign: 'center' }}>
              <ListItemText primary={ni.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem key={99} disablePadding>
          <ListItemButton onClick={e => logout()} sx={{ textAlign: 'center' }}>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>

      </List>
    </Box>
  )

  // const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', flex: '1 1 auto', maxWidth: '500px', width: "100%", height: "100%", mx: "auto" }}>
      <AppBar component="nav" sx={{ backgroundColor: "#353F49" }}>
        <Toolbar variant="dense">
          {/* <Box component="img" sx={{}} /> */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <Menu  />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="settings"
            edge="start"
            href="settings"
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <Settings />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} /> {/* This element pushes content to the right */}
          <Button color="inherit" onClick={installApp}>
            {/* @ts-expect-error */}
            {window?.deferredPrompt ? "Install LegalLoop" : "Installed"}
          </Button>
          <img src={image} alt="LegalLoop" width="50px" />
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          // container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      {/* <Box component="main" sx={{ p: 3 }}> */}
      <Box component="main" sx={{ display: 'flex', width: '100%', p: 2, pt: 9 }}>
        <Outlet />
      </Box>
    </Box> 
  )
}


